












import {numbers} from "@/edinet/libs/numbers";
import Vue, {PropType} from 'vue'

import {Nonfraction, nonfraction} from "@/edinet/libs/ix"
import {scrollToIxTag} from "@/edinet/libs/scroll"
import CollapsibleGroup from '@/edinet/components/CollapsibleGroup.vue'

interface MetricDef {
  name: string
  ixAttr: string
  ctxRef?: string
  renderer?: string
}

interface Metrics {
  name: string
  nonfraction: Nonfraction
  renderer?: string
}

const instance = Vue.extend({
  components: {CollapsibleGroup},
  props: {
    metricsDef: {
      type: Array as PropType<Array<MetricDef>>
    }
  },
  data() {
    return {
      metrics: [] as Metrics[]
    }
  },
  methods: {
    //IMPORTANT: manually call from parent after doc html render
    update: function(): void {
      this.metrics.length = 0 //empty array
      this.metricsDef.forEach(m => {
        const nfs = nonfraction.find(m.ixAttr)
        if (nfs.length > 0) {
          if (m.ctxRef) {
            const nf = nfs.find(x => x.ctxRef === m.ctxRef)
            if (nf) {
              this.metrics.push({
                name: m.name,
                nonfraction: nf,
                renderer: m.renderer
              })
            } else {
              console.warn('no metrics matching context %o in %o', m.ctxRef, nfs)
            }
          } else {
            for (const nf of nfs) {
              this.metrics.push({
                name: m.name,
                nonfraction: nf,
                renderer: m.renderer
              })
            }
          }
        } else {
          console.debug('metrics not found: %o', JSON.stringify(m))
        }
      })
    },
    scrollTo: function(m: Nonfraction): void {
      scrollToIxTag('nonfraction', m.name, m.ctxRef)
    }
  },
  filters: {
    formatNf: function(m: Metrics): string {
      const nf = m.nonfraction
      const v = nf.value * nf.scale
      if (m.renderer && m.renderer === 'percent') {
        return (v * 100).toFixed(2) + '%'
      } else {
        return numbers.formatUnit(v)
      }
    }
  }
})

export default instance
